import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SuiteService } from '../../services/suite/suite.service';

@Component({
  selector: 'app-add-suite-dialog',
  imports: [
    MatDialogModule,
    MatCheckboxModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './add-suite-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './add-suite-dialog.component.scss',
})
export class AddSuiteDialogComponent implements OnInit {
  readonly data = inject(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);
  private suiteService = inject(SuiteService);
  readonly dialogRef = inject(MatDialogRef<AddSuiteDialogComponent>);

  saving = signal(false);
  serverError = signal<string | null>(null);
  suites = signal<any[]>([]);
  form = this.fb.group({
    boxes: new FormArray<FormControl<boolean>>([]),
  });

  ngOnInit(): void {
    this.suiteService
      .getSuitesFromAzureByRelease(this.data.releaseAzureId, this.data.rootSuiteAzureId)
      .subscribe({
        next: (suiteList) => {
          this.suites.set(suiteList);
          this.form = this.fb.group({
            boxes: this.fb.array<FormControl<boolean>>(
              this.suites().map(
                () =>
                  new FormControl(false, {
                    nonNullable: true,
                  }),
              ),
            ),
          });
        },
        error: (err) => console.error('Error loading release Azure suite details:', err),
      });
  }

  get boxes(): FormArray<FormControl<boolean>> {
    return this.form.controls['boxes'] as FormArray<FormControl<boolean>>;
  }

  selectedCount = () => this.boxes.controls.filter((c) => c.value).length;

  selectAll() {
    this.boxes.controls.forEach((c) => c.setValue(true));
  }

  clearAll() {
    this.boxes.controls.forEach((c) => c.setValue(false));
  }

  cancel() {
    this.dialogRef.close({ saved: false });
  }

  save() {
    if (this.saving() || this.selectedCount() === 0) return;

    this.saving.set(true);
    this.serverError.set(null);

    this.boxes.controls.forEach((element, index) => {
      if (element.value) {
        console.log('Selected suite:', this.suites()[index]);
      }
    });

    this.saving.set(false);
    this.dialogRef.close({ saved: true });
  }
}
